export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Если вы отмените сделку, она будет закрыта без завершения операции."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы уверены, что хотите отменить сделку?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Да, отменить"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет, оставить активной"])}
}